import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOpenEnvelopeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.75 8.373 3.75 2.67 3.75-2.67"
    />
    <path
      stroke="#000"
      strokeWidth={1.2}
      d="M1 14.475V6.186c0-.536.276-1.032.728-1.308l6-3.66a1.48 1.48 0 0 1 1.544 0l6 3.66c.451.276.728.772.728 1.308v8.289c0 .842-.672 1.525-1.5 1.525h-12c-.828 0-1.5-.683-1.5-1.525Z"
    />
  </svg>
);
export default SvgOpenEnvelopeIcon;
